const permitConfig = {
  233262: {
    name: 'INYO_NF',
    pages: {
      Venue: {
        rightRail: ['bodyText', 'WalkMeThrough'],
      },
      DetailedAvailability: {
        enableCommercial: true,
        permitTypes: ['overnight-permit', 'overnight-exiting-mt-whitney'],
      },
    },
    components: [
      'GroupDetail',
      'AlternatePermitHolder',
      'CommercialGuideList',
      { name: 'TripItineraryInyo', modifyQuotaButtonText: 'Increase Group Size' },
      'TravelMethod',
      'BringAnimalQuestion',
      'AnimalDetail',
      'IssueStationDetail',
      'LateArrivalQuestion',
      'NeedToKnow',
    ],
  },
  445856: {
    name: 'HUMBOLDT_TOIYABE',
    components: [
      'GroupDetail',
      'AlternatePermitHolder',
      'CommercialGuideList',
      'CommercialServiceType',
      { name: 'TripItinerary', modifyQuotaButtonText: 'Increase Group Size' },
      'TravelMethod',
      'BringAnimalQuestion',
      { name: 'AnimalDetail', IdsPetsExternally: ['8562', '8563'] },
      'LateArrivalQuestion',
      'NeedToKnow',
    ],
  },
  74984: {
    name: 'PARIA_CANYON',
    defaults: {
      minimumStay: 86400,
      maxStay: 1209600,
    },
    pages: {
      Venue: {
        rightRail: ['Calendar', 'GroupSize'],
      },
    },
    components: [
      'GroupDetail',
      'AlternatePermitHolderPC',
      'LaunchPointDetailPariaCanyon',
      'PermitTripDates',
      { name: 'GroupSizeWithGroupMember', modifyQuotaButtonText: 'Increase Group Size'},
      'EmergencyContact',
      'VehicleList',
      'BringAnimalQuestion',
      {
        name: 'AnimalDetail',
        hasFee: true,
        hideStock: true,
        animalsLabels: {
          'Dogs or other pets': 'Dogs',
        },
      },
      'IssueStationDetail',
      'NeedToKnow',
    ],
  },
  445857: {
    name: 'SEKI',
    components: [
      'GroupDetail',
      'AlternatePermitHolder',
      'CommercialServiceType',
      { name: 'TripItineraryInyo', modifyQuotaButtonText: 'Increase Group Size'},
      'BringAnimalQuestion',
      {
        name: 'AnimalDetail',
        hidePets: true,
      },
      'IssueStationDetail',
      'CommentBoxSeki',
      'NeedToKnow',
    ],
  },
  445858: {
    name: 'SIERRA_NF',
    pages: {
      DetailedAvailability: {
        permitTypes: ['overnight-permit', 'overnight-exiting-mt-whitney'], // this one does not have different availability
      },
    },
    components: [
      'GroupDetail',
      'AlternatePermitHolder',
      'CommercialGuideList',
      { name: 'TripItineraryInyo', modifyQuotaButtonText: 'Increase Group Size'},
      'BringAnimalQuestion',
      'AnimalDetail',
      'IssueStationDetail',
      'NeedToKnow',
    ],
  },
  445859: {
    name: 'YOSEMITE_NP',
    lotteryComponents: [
      'GroupDetail',
      'AlternatePermitHolder',
      'LotteryPreferences',
      'NeedToKnow',
    ],
    components: [
      'GroupDetail',
      'AlternatePermitHolder',
      'CommercialGuideList',
      'CommercialServiceType',
      { name: 'TripItineraryInyo', modifyQuotaButtonText: 'Increase Group Size'},
      'CommentBoxYose',
      'TravelMethod',
      'BringAnimalQuestion',
      {
        name: 'AnimalDetail',
        hidePets: true,
      },
      'IssueStationDetail',
      'LateArrivalQuestion',
      'FlexField',
      'NeedToKnow',
    ],
  },
};

// Support for ECMAScript modules and CommonJS
// https://babeljs.io/docs/en/babel-plugin-transform-modules-commonjs
Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = permitConfig;
